import { render } from "./Login.vue?vue&type=template&id=0a5600c8&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=0a5600c8&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a5600c8"]])

export default __exports__